import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { JobData } from '../shared/models/jobs/JobData';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/jobs/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetJobStatus(jobName: string): Observable<JobData> {
    return this.http.get<JobData>(`${this.apiUrl}status/${jobName}`);
  }

  public RunPrebookingProcessor(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}admin-process-prebooking/`, {});
  }

  public RunProcessDealTransactions(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}admin-process-deal-transactions/`, {});
  }

  public RunUpdateAvailableBalance(): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}admin-process-update-available-balance/`, {});
  }
}
